const openGoogleDirections = ({ lat, lng }) => {
  const googleMapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`
  window.open(googleMapsUrl, "_blank")
}

export default openGoogleDirections
